module.exports = __webpack_public_path__ + "img/T1B_xs_02.d4c1ce81.png";